import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const industries = t("marquee.items");
  const row = [...industries, ...industries];
  return (
    <div
      data-testid="industry-marquee"
      className="overflow-hidden border-y border-white/10 bg-coal py-6"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl ${
                i % 2 === 0 ? "text-bone" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="mx-8 h-2 w-2 rotate-45 bg-mint" />
          </span>
        ))}
      </div>
    </div>
  );
}
